<script>
  import {Bar} from 'vue-chartjs'
  export default Bar.extend({
    props: ['days', 'volumes'],
    data () {
      return {
        chartData: {
          labels: this.days,
          datasets: [
            {
              label: ' API Volume Overview (30 Day) ',
              backgroundColor: '#f87979',
              pointBackgroundColor: 'white',
              barPercentage: 1.0,
              categoryPercentage: 1.0,
              pointBorderColor: '#f87979',
              data: this.volumes
            }
          ]
        },
        chartOptions: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.chartOptions)
    }
  })
</script>




// WEBPACK FOOTER //
// app/javascript/components/dashboard/chart.vue?16e58a30